import { IComponent, IOption } from '../Interface/Interface';
import {
  WARRANTY_COMPONENT,
  WARRANTY_GROUP_ATTRIBUTE,
  WARRANTY_YEARS_ATTRIBUTE
} from '../Constants/Constants';

export const filterWarrantyAddonOptions = (
  warrantyAddonOptions: IOption[],
  warrantySelectedOption: IOption | undefined
): IOption[] => {
  if (!warrantySelectedOption) {
    return warrantyAddonOptions;
  }
  const warrantyYearsValue = warrantySelectedOption.attributes.find(
    ({ identifier }) => identifier === WARRANTY_YEARS_ATTRIBUTE
  )?.values?.[0];
  const warrantyGroupValue = warrantySelectedOption.attributes.find(
    ({ identifier }) => identifier === WARRANTY_GROUP_ATTRIBUTE
  )?.values?.[0];

  let filteredOptions = warrantyAddonOptions;

  if (warrantyYearsValue) {
    filteredOptions = filteredOptions.filter((option) =>
      option.attributes.some(
        ({ identifier, values }) =>
          identifier === WARRANTY_YEARS_ATTRIBUTE &&
          values.some(({ value }) => value === warrantyYearsValue.value)
      )
    );
  }

  if (warrantyGroupValue) {
    filteredOptions = filteredOptions.filter((option) =>
      option.attributes.some(
        ({ identifier, values }) =>
          identifier === WARRANTY_GROUP_ATTRIBUTE &&
          values.some(({ value }) => value === warrantyGroupValue.value)
      )
    );
  }

  return filteredOptions;
};

export const getWarrantyAddonOptionsForWarrantyOption = (
  warrantyOptionIdentifier: string,
  selectedAddonOption: IOption,
  optionClassificationsWithOptions: IComponent[],
  addonOptions: IOption[]
): any[] | null => {
  const warrantyOptionToSelect = optionClassificationsWithOptions
    .find(({ identifier }) => identifier === WARRANTY_COMPONENT)
    ?.options.find(({ identifier }) => identifier === warrantyOptionIdentifier);

  addonOptions = filterWarrantyAddonOptions(
    addonOptions,
    warrantyOptionToSelect
  );
  if (!addonOptions.includes(selectedAddonOption) && addonOptions.length > 0) {
    return [
      {
        identifier: selectedAddonOption.identifier,
        amount: 0
      },
      {
        identifier: addonOptions[0].identifier,
        amount: 1
      }
    ];
  }

  return null;
};
